import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';

interface IProductOriginProps {
  product: IProduct;
}

const ProductOrigin: React.FC<IProductOriginProps> = ({ product }) => {
  const tProducts = useTranslations('Products');

  const fabricationOrigin = product.meta.marketing?.made_in_country;
  const ingredientsOrigin = product.meta.marketing?.ingredients_origin;

  if (!fabricationOrigin && !ingredientsOrigin) return null;

  return (
    <>
      <h3 className="tw-lf-body-xbold-md tw-mt-5">{tProducts('origin')}</h3>
      <p className="tw-mt-2 tw-leading-normal">
        {fabricationOrigin &&
          tProducts('fabricationOrigin', { origin: fabricationOrigin })}
        {fabricationOrigin && ingredientsOrigin && <br />}
        {ingredientsOrigin &&
          fabricationOrigin &&
          tProducts('ingredientsOrigin', { origin: ingredientsOrigin })}
        {ingredientsOrigin && !fabricationOrigin && ingredientsOrigin}
      </p>
    </>
  );
};

export default ProductOrigin;
